export default __webpack_public_path__ + "static/media/2-Cloudxier-CSR-Report-Pertamina.ebf94aec.jpg";